// Imports
  // React
  import React, { useContext } from 'react'
  // Context
  import { CartContext } from '../context/CartContext'
  // Firebase
  import { updateComboCode, updateComboPrice } from "../firebase/FirebaseClient";
  // Components
  import CombosCardEdition from './CombosCardEdition'




// rafce

const CombosCard = ({item}) => {

  // Functions
  const { getItem } = useContext(CartContext);
  let itemInCart = getItem(item.name);

  // Limit characters in description button
  const limitedDescription = () => {
    const description = item.description
    const shortDescription = description.substring(0 , 40)+"... "
    if (description.length > 19){
      return shortDescription
    }
    else{
      return description
    }
  }
 

  // Component
  return (
    <>
      <div className='combos-card-image'>
        <span style={{cursor:"pointer"}} onClick={() => updateComboCode(item.id, item.code)}>{item.code}</span>
        <img src={item.picture} alt="Foto del Combo" />
      </div>
      <div className='item-card-info'>
        <div className='item-card-description'>
          <h2>{item.name}</h2>
          <p className='item-card-description'>{limitedDescription()}</p>
          <span style={{cursor:"pointer"}} onClick={() => updateComboPrice(item.id, item.price)} >$ {item.price.toFixed(2)}</span>
        </div>
        <CombosCardEdition item={item} />
      </div>
    </>
  )
}

export default CombosCard

